export default "__VITE_ASSET__CwlOBlRC__"